<template>
  <div>
    <div class="project-edit" v-loading.fullscreen.lock="fullscreenLoading" v-show="!showDialogBox">
      <div class="header">
        <div class="back" @click="$router.go(-1)">返回</div>
        <div class="title">添加/编辑广告</div>
      </div>
      <div class="import-title">
        <span class="cost-title-list-txt">基础信息</span>
      </div>
      <div class="customer-information">
        <div class="cols">
          <div class="col-itms">
            <div class="title"><span>*</span>广告名称</div>
            <el-input size="small" class="w300" maxlength="20" show-word-limit v-model="form.advertName"></el-input>
          </div>
          <div class="col-itms second">
            <div class="title"><span>*</span>广告顺序</div>
            <el-input size="small" @blur="advertSeqBlur" class="w300" placeholder="请填写" v-model="form.advertSeq"></el-input>
          </div>
        </div>

        <div class="cols">
          <div class="col-itms">
            <div class="title"><span>*</span>广告分享</div>
            <el-radio-group class="w300 content-left" @change="changeSharePoster" v-model="form.isSharePoster">
              <el-radio label="Y">支持</el-radio>
              <el-radio label="N">不支持</el-radio>
            </el-radio-group>
          </div>

          <div class="col-itms second">
            <div class="title"><span>*</span>上架状态</div>
            <el-radio-group class="w300 content-left" v-model="form.isUse">
              <el-radio label="Y">上架</el-radio>
              <el-radio label="N">下架</el-radio>
            </el-radio-group>
          </div>
        </div>

        <!-- 广告位图片 -->
        <div class="import-new-wrap">
          <div class="cols">
            <div class="col-itms">
              <div class="title"><span>*</span>广告位图片</div>
              
              <template v-if="!isDisabled">
                <el-upload
                  size="small"
                  class="upload-demo t-left"
                  action="#"
                  ref="createProject"
                  :on-preview="onPreview"
                  :file-list="advertPhotoAttach"
                  accept=".jpg,.png,.jpeg"
                  :auto-upload="true"
                  :http-request="changeMainFile"
                  :before-upload="beforeAvatarUpload"
                  :limit="1"
                  :on-exceed="handleExceed"
                >
                  <div class="file-operate" slot="file" slot-scope="{ file }">
                    <div class="file-name">{{ file.name }}</div>
                    <div class="file-preview" @click="onPreview(file)">查看</div>
                    <div v-if="!isDisabled" class="file-preview" @click="handleMainRemove(file)">删除</div>
                    <div class="file-preview" @click="onDownload(file)">下载</div>
                  </div>
                  <div class="import-btn-tips">
                    <el-button size="mini" class="btn-upload" icon="el-icon-my-import" type="importNew"
                      >导入文件</el-button
                    >
                    <div class="import-step-tip">支持上传jpg、jpeg、png文件，图片尺寸：702*128px</div>
                  </div>
                </el-upload>
              </template>
              <!-- 查看模式 -->
              <template v-else>
                <div v-if="advertPhotoAttach && advertPhotoAttach.length">
                  <div class="file-operate" style="color: #606266" v-for="item in advertPhotoAttach" :key="item.path">
                    <span class="file-name">{{ item.name }}</span>
                    <span class="file-preview" @click="onPreview(item)">查看</span>
                    <span v-if="!isDisabled" class="file-preview" @click="handleMainRemove(item)">删除</span>
                    <span class="file-preview" @click="onDownload(item)">下载</span>
                  </div>
                </div>
                <div v-else>{{ '-' }}</div>
              </template>
            </div>
          </div>
        </div>
        <!-- 广告位图片 -->

        <!-- 海报图片 -->
        <div class="import-new-wrap" v-show="form.isSharePoster ==='Y'">
          <div class="cols">
            <div class="col-itms">
              <div class="title">
                <span>*</span>
                海报图片
              </div>
              <template v-if="!isDisabled">
                <el-upload
                  :disabled="isDisabled"
                  class="upload-demo t-left"
                  action="#"
                  ref="createProjectII"
                  :file-list="posterPhotoAttach"
                  accept=".jpg,.png,.jpeg"
                  :auto-upload="true"
                  :http-request="changeSubFile"
                  :before-upload="beforePosterUpload"
                  :limit="1"
                  :on-exceed="handleExceed"
                >
                  <div class="file-operate" slot="file" slot-scope="{ file }">
                    <div class="file-name">{{ file.name }}</div>
                    <div class="file-preview" @click="onPreview(file)">查看</div>
                    <div v-if="!isDisabled" class="file-preview" @click="handleSubRemove(file)">删除</div>
                    <div class="file-preview" @click="onDownload(file)">下载</div>
                  </div>
                  <div class="import-btn-tips">
                    <el-button size="mini" class="btn-upload" icon="el-icon-my-import" type="importNew"
                      >导入文件</el-button
                    >
                    <div class="import-step-tip">支持上传jpg、jpeg、png文件，单个文件大小≤{{ fileSize }}M</div>
                  </div>
                </el-upload>
              </template>
              <!-- 查看模式 -->
              <template v-else>
                <div v-if="posterPhotoAttach && posterPhotoAttach.length">
                  <div class="file-operate" style="color: #606266" v-for="item in posterPhotoAttach" :key="item.path">
                    <span class="file-name">{{ item.name }}</span>
                    <span class="file-preview" @click="onPreview(item)">查看</span>
                    <span v-if="!isDisabled" class="file-preview" @click="handleMainRemove(item)">删除</span>
                    <span class="file-preview" @click="onDownload(item)">下载</span>
                  </div>
                </div>
                <div v-else>{{ '-' }}</div>
              </template>
            </div>
          </div>
        </div>
         <!-- 海报图片 -->

        <div class="cols" v-show="form.isSharePoster ==='N'">
          <div class="col-itms">
            <div class="title"><span>*</span>目标跳转链接</div>
            <el-radio-group class="w300 content-left" @change="changeUrlType" v-model="form.targetUrlType">
              <el-radio label="1">系统内定页面</el-radio>
              <el-radio label="2">系统外部链接</el-radio>
            </el-radio-group>
          </div>
        </div>

        <div class="cols" v-show="form.isSharePoster ==='N'">
          <div class="col-itms">
            <div class="title"></div>
            <el-select class="w300" size="small" v-show="form.targetUrlType === '1'" @change="changeUrlCode" v-model="form.targetUrlCode" placeholder="请选择">
              <el-option v-for="item in getCodeListByKey('广告目标页面')" :label="item.text" :value="item.guid" :key="item.guid"> </el-option>
            </el-select>
            <el-input
              v-show="form.targetUrlType === '2'"
              v-model="form.targetUrlValue"
              size="small"
              class="w300"
              placeholder="请填写链接地址"
            ></el-input>
          </div>
        </div>
      </div>

      <div class="operte-btns">
        <div class="btn cancel" @click="$router.go(-1)">取消</div>

        <div v-if="!isDisabled" class="btn submit" @click="saveReq">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
import { bpmnroute } from '@/api/apiRoute';
export default {
  components: {},
  data() {
    return {
      fullscreenLoading: false,
      invoiceTenantList: [], //开票方list
      receiveTenantList: [], //接收方list
      allList: [], // 开票方接收方合并的list
      collectionList: [],
      paymentCollectionStatusList: [
        //回款状态list
        {
          text: '待回款',
          value: 'N',
        },
        {
          text: '已回款',
          value: 'Y',
        },
      ],
      contractList: [], //合同list
      guid: '',
      form: {
        advertName:'',
        advertSeq:'',
        isSharePoster:'',
        isUse:'Y', // 默认上架设置
        targetUrlType:'',
        targetUrlValue:'',
        advertPhotoUrl:'',
        posterPhotoUrl:'',
      },
      advertPhotoAttach: [],
      posterPhotoAttach: [],
      fileSize: serverConfig.FILE_SIZE,
      paramCollection: {
        // 新增收款信息传递参数
        streamType: '1',
        index: '', // 款项信息的索引
        title: '新增上游收款信息',
        operationType: '关联新增方式',
        invoiceTenantGuid: '', // 收票方（支付方）唯一标识
        invoiceTenantName: '', // 收票方（支付方）name
        receiveTenantGuid: '', // 开票方（收款方）唯一标识
        receiveTenantName: '', // 开票方（收款方）name
        counterpartGuid: '', //对应款项
      },
      showDialogBox: false, // 显示收款信息表单
      restaurants: [],
    };
  },
  watch: {},
  computed: {
    showCheckPayment() {
      // !上传付款通知书校验触发标识
      return this.form.bizTypeGuid === '1' ? true : false;
    },
    isDisabled() {
      // !查看模式
      return this.$route.query.operationMode === 'look';
    },
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      let self = this;
      let query = {
        guid: this.$route.query.guid,
      };
      if (!this.$route.query.guid) return;
      self.api.postJson(`/${serverConfig.msConfigureService}/advert/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE && res.data.data.records.length) {
          let form = res.data.data.records[0];
          form.advertPhotoAttach = form.advertPhotoUrl ? JSON.parse(form.advertPhotoUrl) : [];
          form.posterPhotoAttach = form.posterPhotoUrl ? JSON.parse(form.posterPhotoUrl) : [];
          form.advertPhotoAttach &&
            form.advertPhotoAttach.forEach((item) => {
              this.advertPhotoAttach.push({
                name: item.filename,
                path: item.path,
              });
            });
          form.posterPhotoAttach &&
            form.posterPhotoAttach.forEach((item) => {
              this.posterPhotoAttach.push({
                name: item.filename,
                path: item.path,
              });
            });
          form.targetUrlCode = form.targetUrlCode
          this.form = form;
          this.guid = form.guid;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },

    //获取开票方
    getInvoiceTenantList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: ['9901', '9904'],
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.invoiceTenantList = res.data.data.records;
          this.allList = this.allList.concat(self.invoiceTenantList);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //开票方change
    invoiceNameChange(val) {
      const filterItem = this.invoiceTenantList.filter((item) => item.guid == val);
      this.form.invoiceTenantName = filterItem[0].tenantName;
    },
    //获取收票方
    getReceiveTenantList() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.receiveTenantList = [];
            res.data.data.forEach((item) => {
              self.receiveTenantList.push({
                guid: item.sendTenantGuid,
                tenantName: item.sendTenantName,
              });
            });
            this.allList = this.allList.concat(self.receiveTenantList);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //收票方change
    receiveNameChange(val) {
      const filterItem = this.receiveTenantList.filter((item) => item.guid == val);
      this.form.receiveTenantName = filterItem[0].tenantName;
    },
    //获取合同
    getContractList() {
      let userinfo = JSON.parse(localStorage.userInfo);
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        // staffGuid: userinfo.staffGuid,
        approveState: 'Y',
        tenantGuid: this.form.receiveTenantGuid, // 甲方(收票)企业
        serviceTenantGuid: this.form.invoiceTenantGuid, // 乙方(开票)企业
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/contract/list`, req).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.contractList = res.data.data.records || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //合同change
    contractNameChange(val) {
      const filterItem = this.contractList.filter((item) => item.contractCode == val);
      this.form.contractName = filterItem[0].contractName;
    },
    // 合同fouce
    contractNameFoucs() {
      if (!this.form.receiveTenantGuid || !this.form.invoiceTenantGuid) {
        this.$message({
          message: '请勾选开票方和收票方',
          type: 'warning',
        });
        return;
      }
      this.getContractList();
    },
    addReceiveItem() {
      if (this.form.invoices) {
        this.form.invoices.push({
          invoiceNo: '',
          receiveDate: '',
          receiveAmount: '',
          isCapitalAdvances: 'N',
          selectItem: {},
        });
      } else {
        this.form.invoices = [];
        this.form.invoices.push({
          invoiceNo: '',
          receiveDate: '',
          receiveAmount: '',
          isCapitalAdvances: 'N',
          selectItem: {},
        });
      }
    },
    delReceiveItem(index) {
      let self = this;
      self
        .$confirm('确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          this.form.invoices.splice(index, 1);
        });
    },
    //提交申请
    saveReq() {
      if (!this.checkForm()) {
        return;
      }
      let form = JSON.parse(JSON.stringify(this.form));
      let advertPhotoAttach = []
      let posterPhotoAttach = []
      let reqUrl;
      this.advertPhotoAttach.forEach((item) => {
        advertPhotoAttach.push({
          filename : item.name,
          path : item.path
        })
      });
      this.posterPhotoAttach.forEach((item) => {
        posterPhotoAttach.push({
          filename : item.name,
          path : item.path
        })
      });
      form.posterPhotoUrl = posterPhotoAttach.length ? JSON.stringify(posterPhotoAttach) : null;
      form.advertPhotoUrl = advertPhotoAttach.length ? JSON.stringify(advertPhotoAttach) : null;
      if (this.guid) {
        reqUrl = `/${serverConfig.msConfigureService}/advert/data/update`;
        form.guid = this.guid;
      } else {
        reqUrl = `/${serverConfig.msConfigureService}/advert/data/add`;
        form.guid = null;
      }
      this.fullscreenLoading = true;
      this.api.postJson(reqUrl, form).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$message({
            message: '新增成功',
            type: 'success',
          });
          this.$router.go(-1);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    onPreview(file) {
      var fileSuffix = file.name ? file.name.substring(file.name.lastIndexOf('.') + 1) : '';
      if (fileSuffix === 'png' || fileSuffix === 'jpeg' || fileSuffix === 'jpg' || fileSuffix === 'pdf') {
        return window.open(file.path, file.name);
      }
      window.open('https://view.officeapps.live.com/op/view.aspx?src=' + file.path);
    },
    onDownload(file) {
      window.open(file.path + '?response-content-type=application/octet-stream');
    },
    async beforeAvatarUpload(file) {
      if (file.type) {
        if (!(file.type.indexOf('jpg') >-1 || file.type.indexOf('jpeg') >-1 || file.type.indexOf('png') >-1)) {
          this.$message.error('请上传图片格式' )
          return Promise.reject(false)
        }
      }
      const isSize = await new Promise(function (resolve, reject) {
        let width = 702
        let height = 128
        let _URL = window.URL || window.webkitURL
        let image = new Image()

        image.onload = function () {
          const valid =
            image.width === width &&
            image.height === height
          valid ? resolve() : reject()
        }
        image.src = _URL.createObjectURL(file)
      }).then(
        () => {
          return file
        },
        () => {
          this.$message.error(
            '分辨率必须为702*128px'
          )
          return Promise.reject(false)
        }
      )
    },
    beforePosterUpload(file) {
      if (file.type) {
        if ((file.type.indexOf('jpg') >-1 || file.type.indexOf('jpeg') >-1 || file.type.indexOf('png') >-1)) {
            return file
          } else {
          this.$message.error('请上传图片格式' )
           return Promise.reject(false)
        }
      }
    },
    handleMainRemove(file) {
      this.advertPhotoAttach.forEach((item, index) => {
        if (item.path == file.path) {
          this.advertPhotoAttach.splice(index, 1);
        }
      });
    },
    // 上传文件
    changeMainFile(file) {
      let isLt5M = file.file.size / 1024 / 1024 < serverConfig.FILE_SIZE;
      if (!isLt5M) {
        this.$message.error(`上传文件大小不能超过${serverConfig.FILE_SIZE}MB`);
        this.$refs.createProject.clearFiles(); // 清除前端显示的文件列表
        return;
      }
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('fileName', file.file.name);
      this.fullscreenLoading = true;
      this.api
        .postImage(`/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`, formData)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.advertPhotoAttach.push({
              name: file.file.name,
              path: res.data.data.data,
            });
            this.$message({
              message: '上传成功',
              type: 'success',
            });
          } else {
            this.$message.error('上传失败!');
          }
        })
        .catch(() => {
          this.$message('上传失败！');
        });
    },
    changeSubFile(file) {
      let isLt5M = file.file.size / 1024 / 1024 < serverConfig.FILE_SIZE;
      if (!isLt5M) {
        this.$message.error(`上传文件大小不能超过${serverConfig.FILE_SIZE}MB`);
        this.$refs.createProjectII.clearFiles(); // 清除前端显示的文件列表
        return;
      }
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('fileName', file.file.name);
      this.fullscreenLoading = true;
      this.api
        .postImage(`/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`, formData)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.posterPhotoAttach.push({
              name: file.file.name,
              path: res.data.data.data,
            });
            this.$message({
              message: '上传成功',
              type: 'success',
            });
          } else {
            this.posterPhotoAttach = [];
            this.$message.error('上传失败!');
          }
        })
        .catch(() => {
          this.$message('上传失败！');
        });
    },
    handleSubRemove(file) {
      this.posterPhotoAttach.forEach((item, index) => {
        if (item.path == file.path) {
          this.posterPhotoAttach.splice(index, 1);
        }
      });
    },
    handleExceed(files, fileList) {
      this.fileList = [];
      this.$message.warning('当前限制选择1个文件');
    },
    advertSeqBlur() {
      if (this.form.advertSeq) {
        this.form.advertSeq = this.form.advertSeq.toString().replace(/[^0-9]/g,'')
      }
    },
    checkForm() {
      if (!this.form.advertName) {
        this.$message.error('广告名称不能为空');
        return false;
      }
      if (!this.form.advertSeq) {
        this.$message.error('广告顺序不能为空');
        return false;
      }
      if (!this.form.isSharePoster) {
        this.$message.error('广告分享状态不能为空');
        return false;
      }
      if (!this.form.isUse) {
        this.$message.error('上架状态不能为空');
        return false;
      }
      if (!this.advertPhotoAttach.length) {
        this.$message.error('广告位图片不能为空');
        return false;
      }

      if (this.form.isSharePoster === 'Y') {
        if (!this.posterPhotoAttach.length) {
          this.$message.error('海报图片不能为空');
          return false;
        }
      }

      if (this.form.isSharePoster === 'N') {
        if (!this.form.targetUrlType) {
          this.$message.error('目标跳转类型不能为空');
          return false;
        }
        if (!this.form.targetUrlValue) {
          this.$message.error('目标跳转链接不能为空');
          return false;
        }
      }
      return true;
    },
    // 去添加收款信息
    addCollectionInfo(index) {
      if (!this.form.receiveTenantGuid || !this.form.invoiceTenantGuid) {
        this.$message({
          message: '请勾选开票方和收票方',
          type: 'warning',
        });
        return;
      }
      let { form } = this;
      this.showDialogBox = true;
      this.$refs.AddCollectionDialogBox.outerVisible = true;
      this.paramCollection.index = index; // 对应编辑的索引
      this.paramCollection.invoiceTenantGuid = form.invoiceTenantGuid; // 收票方（支付方）唯一标识
      this.paramCollection.invoiceTenantName = this.findName(form.invoiceTenantGuid, this.invoiceTenantList) || ''; // 收票方（支付方）name
      this.paramCollection.receiveTenantGuid = form.receiveTenantGuid; // 开票方（收款方）唯一标识
      this.paramCollection.receiveTenantName = this.findName(form.receiveTenantGuid, this.receiveTenantList) || ''; // 开票方（收款方）唯一标识
      this.paramCollection.counterpartGuid = form.counterpartGuid;
    },
    findName(guid, list) {
      let itemObj = list.find((item) => item.guid === guid);
      return itemObj && itemObj.tenantName;
    },
    // 获取添加的收款信息
    getCollectionInfo(val) {
      let { paramCollection } = this;
      let { form } = this;
      let invoicesItem = form.invoices[paramCollection.index];
      invoicesItem.guid = val.guid;
      invoicesItem.accountType = val.accountType;
      invoicesItem.bankAccount = val.bankAccount;
      invoicesItem.bankName = val.bankName;
      invoicesItem.correspondItem = val.correspondItem;
      invoicesItem.isCapitalAdvances = val.isCapitalAdvances;
      invoicesItem.payTenantGuid = val.payTenantGuid;
      invoicesItem.payTenantName = val.payTenantName;
      invoicesItem.receiveAmount = val.receiveAmount;
      invoicesItem.receiveDate = val.receiveDate;
      invoicesItem.receiveTenantGuid = val.receiveTenantGuid;
      invoicesItem.receiveTenantName = val.receiveTenantName;
      invoicesItem.label = `${this.getCorrespondItemName(invoicesItem.correspondItem) || ''}-${
        invoicesItem.receiveDate
      }`;
      invoicesItem.originalLabel = `${this.getCorrespondItemName(invoicesItem.correspondItem) || ''}-${
        invoicesItem.receiveDate
      }`;
    },
    closedDialogBox(val) {
      if (val === 'closed') {
        this.showDialogBox = false;
      }
    },
    getCorrespondItemName(value) {
      let itemObj = this.getCodeListByKey('对应款项').find((item) => item.value === value);
      return itemObj && itemObj.text;
    },
    // 收款信息change时间
    collectionChange(guid, index) {
      let collectionItem = this.collectionList.find((item) => item.guid === guid);
      let selectItem = this.form.invoices[index].selectItem;
      selectItem = Object.assign(selectItem, collectionItem);
    },
    handleIconClick() {},
    getCollectionInfoLabel(invoices) {
      // 设置收款内容label
      if (invoices && Array.isArray(invoices)) {
        invoices.forEach((item) => {
          if (item.correspondItem && item.receiveDate) {
            item.label = `${this.getCorrespondItemName(item.correspondItem) || ''}-${item.receiveDate}`;
            item.originalLabel = `${this.getCorrespondItemName(item.correspondItem) || ''}-${item.receiveDate}`;
          }
        });
      }
    },
    // 防止修改
    invoiceNameInput(index) {
      let { form } = this;
      let { invoices } = form;
      let item = invoices.find((iten, i) => i === index);
      item.label = item.originalLabel;
    },
    // 打开收款信息列表
    showCollectionList(index) {
      if (!this.form.receiveTenantGuid || !this.form.invoiceTenantGuid) {
        this.$message({
          message: '请勾选开票方和收票方',
          type: 'warning',
        });
        return;
      }
      let { form } = this;
      this.paramCollection.index = index;
      this.$root.$emit('openCollectionList', {
        streamType: '1',
        payTenantGuid: form.receiveTenantGuid,
        receiveTenantGuid: form.invoiceTenantGuid,
      });
    },
    // todo change事件集合
    changeUrlCode(guid) {
      if (guid) {
        let url = this.getCodeListByKey('广告目标页面').find(item=>item.guid === guid)
        // this.$set(this.form,'targetUrlValue', url.value)
        // this.$set(this.form,'targetUrlCode', guid)
        this.form.targetUrlValue = url.value
        this.form.targetUrlCode= guid
      }
    },
    changeUrlType(type) {
      this.form.targetUrlCode = ''
      this.form.targetUrlValue =  ''
    },
    changeSharePoster() {
      this.form.targetUrlType = ''
      this.form.targetUrlCode = ''
      this.form.targetUrlValue =  ''
      this.posterPhotoAttach = []
    }
  },
};
</script>

<style lang="less" scoped>
/deep/.el-input-number__decrease {
  display: none;
}
/deep/.el-input-number__increase {
  display: none;
}
/deep/ .el-input-number .el-input__inner {
  text-align: left;
  padding-left: 15px;
}
.iframe-sty {
  width: 100%;
  border: none;
  height: 600px;
}

.flow {
  background: #fff;
  padding-left: 20px;
  margin-top: 4px;
}

.pdt100 {
  padding-bottom: 100px !important;
}

.header {
  background: #fff;
  margin: 4px 0;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 16px;
}

.header .back {
  background: #ffffff;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
}

.import-title {
  text-align: left;
  background: #fff;
  padding: 10px 16px;
  font-size: 16px;
  position: relative;
}

.empty-tooltip {
  background: #fff;
  font-size: 16px;
  padding: 25px 0;
}

.import-title.second {
  margin-top: 4px;
}

.header .title {
  text-align: center;
  flex: 1;
}

.customer-information {
  background: #fff;
  padding-bottom: 15px;
}

.customer-information .sub-title {
  text-align: left;
  font-size: 14px;
  line-height: 28px;
  padding: 10px 16px;
  display: flex;
  justify-content: space-between;
}

.sub-operate-add {
  color: #4fa1a4;
  margin-left: 14px;
  cursor: pointer;
}

.sub-operate-add2 {
  color: #4fa1a4;
  font-size: 14px;
  margin-left: 14px;
  cursor: pointer;
  position: absolute;
  right: 35px;
  top: 10px;
  text-align: center;
}

.sub-operate-del {
  font-size: 14px;
  color: #4fa1a4;
  cursor: pointer;
  text-align: center;
  margin: 0 20px;
}

.customer-information .cols {
  background: #fff;
  display: flex;
  padding: 4px 16px;
  padding-left: 20px;
}

.customer-information .col-itms {
  display: flex;
  align-items: center;
  margin-left: 20px;
}

.customer-information .col-itms .title {
  width: 120px;
  text-align: right;
  margin-right: 16px;
}

.customer-information .col-itms.second {
  margin-left: 170px;
}

.customer-information .col-itms .title span {
  color: red;
}

.import-new-wrap {
  padding-bottom: 15px;
}

.import-new-wrap .import-step-tip {
  text-align: left;
  padding-left: 10px;
  color: #666;
  font-size: 12px;
}

.import-new-wrap .col-itms {
  align-items: baseline;
}

.operte-btns {
  background: #fff;
  margin-top: 2px;
  display: flex;
  justify-content: center;
  padding: 25px 0;
}

.operte-btns .btn {
  padding: 5px 18px;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  cursor: pointer;
  margin-right: 10px;
}

.operte-btns .btn.save {
  border: 1px solid #4FA1A4;
  color: #4FA1A4;
  cursor: pointer;
}

.operte-btns .btn.submit {
  border: 1px solid #4FA1A4;
  background: #4FA1A4;
  color: #fff;
  cursor: pointer;
}
.file-operate {
  display: flex;
}
.file-preview {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  cursor: pointer;
  color: #4fa1a4;
}
.bank-content {
  text-align: left;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.1285, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.1285, 0.045, 0.355, 1);
}
.bank-info {
  color: #a7a7a7;
}

.content-left {
  text-align: left;
}
.btn-upload {
  width: 84px;
  height: 28px;
  padding: 0;
}
</style>
